<template>
  <div id="app">
    <sidebar class="sidebar" :logo=" content && content.logo.path "></sidebar>
    <main class="main">
      <div class="main__content">
        <router-view :general=" content && content "/>
      </div>
      <footer class="main__footer">
        <span class="main__footer__static">
          {{ content && content.title }}
        </span>
        <div class="main__footer__links">
          <a href="#kontakt" @click=" route() ">Kontakt</a> &ndash;
          <router-link to="/satzung">Satzung</router-link> &ndash;
          <router-link to="/datenschutz">Datenschutz</router-link> &ndash;
          <router-link to="/impressum">Impressum</router-link> &ndash;
          <a href="//cockpit.club-der-100.de">Login</a>
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
import {api} from '@/main.js'
import Sidebar from '@/components/sidebar'

export default {
  name: 'App',
  components: {
    Sidebar
  },
  data () {
    return {
      content: false
    }
  },
  methods: {
    route() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    }
  },
  mounted () {
    api.singleton.get('general').then(response => {
      this.content = JSON.parse(response.data)
      this.content.logo.path = api.url + this.content.logo.path

      document.title = this.content.title
    })
  }
}
</script>

<style lang="scss">
  // Reboot as style reset
  @import 'assets/styles/_reboot';

  html, body, #app {
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  @import url('https://fonts.googleapis.com/css?family=Open+Sans');
  body {
    font-family: 'Open Sans', sans-serif;
    background: $background;
    color: $text;
  }

  a {
    color: #000;
    font-weight: bold;
    text-decoration: none;
    border-bottom: 1px solid transparent;

    &[href^="//"],
    &[href^="http"] {
      font-style: italic;
    }

    &:hover,
    &:focus {
      color: #000;
      text-decoration: none;
      border-bottom-color: currentColor;
    }
  }
</style>

<style lang="scss" scoped>
  $sidebarWidth: 20%;

  #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
  }
  .sidebar {
    height: 100%;
    width: $sidebarWidth;

    @media (max-width: 777px) {
      display: none;
    }
  }
  .main {
    height: 100%;
    width: #{ 100% - $sidebarWidth };
    margin-left: $sidebarWidth;

    &__content {
      min-height: 100%;
      background-color: #fcfcfe;
    }
    &__footer {
      background: $gray-dark;
      color: $text-inverse;
      font-size: .85rem;
      text-align: center;
      padding: 1rem 2rem;
      display: flex;
      justify-content: space-between;

      &__links,
      &__static {
        opacity: .5;
      }
      &__links a {
        font-size: .85rem;
        color: $text-inverse;

        &:hover, &:focus {
          border-bottom: 1px solid;
          text-decoration: none;
        }
      }

      @media (max-width: 777px) {
        flex-direction: column;
        padding: 1rem .5rem;
      }
    }

    @media (max-width: 777px) {
      width: 100%;
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue